import { createContext, useContext } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const ReCaptchaContext = createContext();

export const ReCaptchaProvider = ({ children }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Lf4m1UrAAAAABkTd7MHA6JzyLrlmPNgaWCIqgTb"
      language="pl"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

const useReCaptcha = () => useContext(ReCaptchaContext);

export { useReCaptcha };
export default ReCaptchaProvider;
